import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import Chart from './Chart'
import GroupedEventsByReasonLoader from './_load/GroupedEventsByReasonLoader'
import PeriodDescription from '../../_shared/PeriodDescription'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import StatusDropdown from './StatusDropdown'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
        <StatusDropdown widget={widget} />
      </Grid>

      <Separator weight={2} />
      <GroupedEventsByReasonLoader>
        <Chart widget={widget} />
      </GroupedEventsByReasonLoader>
    </WidgetWrapper>
  )
}

export default Widget
